import { Form } from "antd";
import QueryString from "qs";
import { useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
/**
 * @param 表单默认属性值 defaultValues
 * @param  route切换后执行的方法 fetchData
 * @returns returns.form:form对象
 * @returns returns.asyncToRoute:同步属性值到route
 */
export default function useFormAndRoute(defaultValues = {}, fetchData) {
  const [form] = Form.useForm();
  const { pathname, search } = useLocation();
  const history = useHistory();
  useEffect(() => {
    let formValues = {};
    let queryObj = QueryString.parse(decodeURIComponent(search.replace("?", "")));
    Object.keys(form.getFieldsValue()).forEach((k) => {
      formValues[k] = queryObj[k] || defaultValues[k] || null;
    });
    form.setFieldsValue(formValues);
    fetchData(form.getFieldsValue());
  }, [search, form, fetchData, defaultValues]);
  const asyncToRoute = (formDateValues) => {
    history.replace(pathname + "?" + encodeURI(QueryString.stringify(formDateValues)));
  };
  return {
    form,
    asyncToRoute,
  };
}
